export const TECHNICAL_SUPPORT = 'https://www.checkpoint.com/support-services/contact-support';
